/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_vat_and_tax = /** @type {(inputs: {}) => string} */ () => {
	return `Včetně DPH a dalších daní`
};

const da_vat_and_tax = /** @type {(inputs: {}) => string} */ () => {
	return `Inkl. moms & andre afgifter`
};

const de_vat_and_tax = /** @type {(inputs: {}) => string} */ () => {
	return `inkl. MwSt. & weitere Steuern`
};

const en_vat_and_tax = /** @type {(inputs: {}) => string} */ () => {
	return `Incl. VAT & other taxes`
};

const es_vat_and_tax = /** @type {(inputs: {}) => string} */ () => {
	return `Incluye IVA y otros impuestos`
};

const fr_vat_and_tax = /** @type {(inputs: {}) => string} */ () => {
	return `Dont TVA & autres taxes`
};

const hu_vat_and_tax = /** @type {(inputs: {}) => string} */ () => {
	return `Tartalmazza az ÁFA-t és egyéb adókat`
};

const it_vat_and_tax = /** @type {(inputs: {}) => string} */ () => {
	return `Inclusa IVA & altre tasse`
};

const nl_vat_and_tax = /** @type {(inputs: {}) => string} */ () => {
	return `Incl. btw & andere belastingen`
};

const pl_vat_and_tax = /** @type {(inputs: {}) => string} */ () => {
	return `W tym VAT i inne podatki`
};

const pt_vat_and_tax = /** @type {(inputs: {}) => string} */ () => {
	return `Inclui IVA & outros impostos`
};

const sv_vat_and_tax = /** @type {(inputs: {}) => string} */ () => {
	return `Inkl. moms & andra skatter`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const vat_and_tax = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.vat_and_tax(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("vat_and_tax", locale)
	if (locale === "cs") return cs_vat_and_tax(inputs)
	if (locale === "da") return da_vat_and_tax(inputs)
	if (locale === "de") return de_vat_and_tax(inputs)
	if (locale === "en") return en_vat_and_tax(inputs)
	if (locale === "es") return es_vat_and_tax(inputs)
	if (locale === "fr") return fr_vat_and_tax(inputs)
	if (locale === "hu") return hu_vat_and_tax(inputs)
	if (locale === "it") return it_vat_and_tax(inputs)
	if (locale === "nl") return nl_vat_and_tax(inputs)
	if (locale === "pl") return pl_vat_and_tax(inputs)
	if (locale === "pt") return pt_vat_and_tax(inputs)
	return sv_vat_and_tax(inputs)
};